import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../../utils/api';
import BottomNav from '../../../components/layout/BottomNav';
import BackButton from '../../../components/common/BackButton';

const G     = '#166534';
const LIGHT = '#DCFCE7';

const STATUS_PILL = {
  pending:  { bg:'#FEF9C3', color:'#854D0E', label:'Pending Verification' },
  active:   { bg:'#DCFCE7', color:'#166534', label:'Live' },
  rejected: { bg:'#FEE2E2', color:'#991B1B', label:'Rejected' },
};

export default function LandMyListingsPage() {
  const navigate = useNavigate();
  const [listings, setListings] = useState([]);
  const [loading,  setLoading]  = useState(true);

  useEffect(() => { load(); }, []);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get('/land/my-listings');
      setListings(data.listings || data.data || []);
    } catch { setListings([]); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ background:'#F5F7FA', minHeight:'100vh', fontFamily:'Inter,system-ui,sans-serif', paddingBottom:90 }}>

      <div style={{ background:G, padding:'14px 16px 14px', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
        <BackButton />
        <div style={{ fontSize:17, fontWeight:700, color:'white' }}>My Listings</div>
        <button onClick={() => navigate('/land/add')}
          style={{ width:34, height:34, borderRadius:'50%', background:'rgba(255,255,255,.2)', border:'none', color:'white', fontSize:18, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>
          +
        </button>
      </div>

      <div style={{ padding:'14px 14px 0' }}>
        {loading ? (
          <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
            {[1,2].map(i => <div key={i} style={{ height:110, background:'white', borderRadius:16, opacity:.5 }} />)}
          </div>
        ) : listings.length === 0 ? (
          <div style={{ textAlign:'center', padding:'60px 0', color:'#9CA3AF' }}>
            <div style={{ fontSize:44, marginBottom:10 }}>📋</div>
            <div style={{ fontSize:14, marginBottom:14 }}>You haven't listed any property yet</div>
            <button onClick={() => navigate('/land/add')}
              style={{ background:G, color:'white', border:'none', borderRadius:10, padding:'10px 20px', fontSize:13, fontWeight:700, cursor:'pointer' }}>
              + Add Property
            </button>
          </div>
        ) : (
          <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
            {listings.map(item => {
              const pill = STATUS_PILL[item.status] || STATUS_PILL.pending;
              return (
                <div key={item._id} onClick={() => navigate(`/land/${item._id}`)}
                  style={{ background:'white', borderRadius:16, border:'0.5px solid #E5E7EB', display:'flex', gap:10, padding:8, cursor:'pointer' }}>
                  <div style={{ width:88, height:88, borderRadius:12, overflow:'hidden', background:LIGHT, flexShrink:0 }}>
                    {item.photos?.[0] && <img src={item.photos[0]} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} />}
                  </div>
                  <div style={{ flex:1, paddingTop:2 }}>
                    <div style={{ fontSize:13, fontWeight:700, color:'#1a1a1a' }}>{item.title}</div>
                    <div style={{ fontSize:11, color:'#9CA3AF', margin:'4px 0' }}> {item.address}</div>
                    <span style={{ fontSize:10, fontWeight:700, color:pill.color, background:pill.bg, padding:'3px 10px', borderRadius:10 }}>
                      {pill.label}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <BottomNav />
    </div>
  );
}